var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0166 2.42578C7.25828 2.42578 5.01662 4.66745 5.01662 7.42578V9.83411C5.01662 10.3424 4.79995 11.1174 4.54162 11.5508L3.58328 13.1424C2.99162 14.1258 3.39995 15.2174 4.48328 15.5841C8.07495 16.7841 11.95 16.7841 15.5416 15.5841C16.55 15.2508 16.9916 14.0591 16.4416 13.1424L15.4833 11.5508C15.2333 11.1174 15.0166 10.3424 15.0166 9.83411V7.42578C15.0166 4.67578 12.7666 2.42578 10.0166 2.42578Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5583 2.66719C11.3 2.59219 11.0333 2.53385 10.7583 2.50052C9.95831 2.40052 9.19164 2.45885 8.47498 2.66719C8.71664 2.05052 9.31664 1.61719 10.0166 1.61719C10.7166 1.61719 11.3166 2.05052 11.5583 2.66719Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5167 15.8828C12.5167 17.2578 11.3917 18.3828 10.0167 18.3828C9.33339 18.3828 8.70006 18.0995 8.25006 17.6495C7.80006 17.1995 7.51672 16.5661 7.51672 15.8828",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.62dddd12097585d917abd66a8104ea25.svg";
export { ForwardRef as ReactComponent };